<template>
  <div>
    <PageTitle v-bind:title="'Annotators'" />

    <b-container fluid="xxl" class="mt-2">
      <b-row class="mt-4">
        <b-col>
          <b-button variant="primary" v-if="config.editable" :disabled="!$store.getters.checkRole('legam.bib.annotator.add')" size="sm" class="float-right mb-4" v-b-modal.modal-new-annotator>
            <b-icon icon="plus-circle-fill" aria-hidden="true"></b-icon>
            Add new annotator
          </b-button>
          <b-modal id="modal-new-annotator" title="New annotator" ok-title="Save" @ok="saveAnnotator" size="lg">
            <AnnotatorNewEdit />
          </b-modal>
          <LegamDataTables
            v-if="config.editable"
            v-bind="$data"
            @selectChanged="selectChanged"
          />
          <LegamDataTablesClientSide v-else v-bind="$data" @click="openDetails" />
        </b-col>
      </b-row>
    </b-container>

    <div class="merge-float" v-if="selected.length">
      <b-badge href="#" variant="info" class="mr-1" v-for="annotator in selected" :key="annotator.id" @click="removeSelected(annotator)">
        <span v-html="annotator.name"></span>
        <b-icon icon="trash" aria-hidden="true" class="ml-1"></b-icon>
      </b-badge>
      <span class="btn-legam-xxs btn-legam-xs btn-legam-blue" v-if="selected.length > 1" v-b-modal.modal-merge>
        <b-icon icon="plus-circle-fill" aria-hidden="true"></b-icon>
        Merge annotators
      </span>
      <span class="btn-legam-xxs btn-legam-xs" @click="selected = []">
        <b-icon icon="x" aria-hidden="true"></b-icon>
      </span>
      <b-modal id="modal-merge" title="Merge annotators" ok-title="Merge" @ok="merge" size="md">
        <b-badge href="#" variant="info" class="mr-1" v-for="annotator in selected" :key="'modal' + annotator.id" @click="removeSelected(annotator)">
          <span v-html="annotator.name"></span>
          <b-icon icon="trash" aria-hidden="true" class="ml-1"></b-icon>
        </b-badge>
        <!-- <b-form-group
          id="main-entity-grp"
          label="Merge to"
          label-for="main-entity"
          class="mt-3"
          description="This annotator will keep all its data (other annotators will move their data to this annotator and then disappear)"
        >
          <b-form-select
            v-model="mainEntityId"
            :options="selected.map(annotator => {
              return {
                'text': annotator.name,
                'value': annotator.id
              }
            })"
          ></b-form-select>
        </b-form-group> -->
      </b-modal>
    </div>
  </div>
</template>

<style scoped>
  * >>> .tdAction {
    width: 150px;
  }
  * >>> .tdManuscriptDates {
    width: 130px;
  }

  * >>> .btn-legam-dt-filter:hover ~ * >>> .filter-box {
    display: block;
  }
  .merge-float {
    position: fixed;
    bottom: 15px;
    left: 20px;
    background-color: #bebebe9a;
    padding: 3px 8px 5px;
    border-radius: 3px;
  }
</style>

<script>
  import { mapState } from 'vuex'
  import router from '@/router'
  import PageTitle from '@/components/PageTitle.vue'
  import LegamDataTables from '@/components/LegamDataTables.vue'
  import LegamDataTablesClientSide from '@/components/LegamDataTablesClientSide.vue'
  import tdColAction from "@/components/tdColAction"
  import AnnotatorNewEdit from "@/components/Bibliography/AnnotatorNewEdit"
  import tdColUUID from "@/components/tdColUUID"
  import HelpStore from '@/store/helpstore.js'
  import config from '@/config.js'

  export default {
    name: 'AnnotatorList',
    data(){
      return {
        columns: [
          { title: 'ID', field: 'id', sortable: true, searchable: true, tdComp: tdColUUID },
          { title: 'Name', field: 'name', sortable: true, searchable: true },
          { title: 'Action', field: 'id', tdComp: tdColAction, thClass: 'tdAction',
            transformData: function(row){
              return [
                { text: null, icon: 'list-ul', id: row.sigleLegam, to: {
                  name: 'AnnotatorDetails',
                  params: {
                    id: row.id
                  }}
                }
              ]
            }
          }
        ],
        columnsPI: [
          { title: 'Name', field: 'name', sortable: true, searchable: true }
        ],
        url: '/annotators/datatables',
        key: 1,
        searchableByColumn: true,
        selected: [],
        mainEntityId: null,
        config: config,
      }
    },
    computed: {
      ...mapState({
        userSettings: state => state.user.settings
      })
    },
    components: {
      PageTitle,
      LegamDataTables,
      LegamDataTablesClientSide,
      AnnotatorNewEdit
    },
    methods: {
      saveAnnotator(){
        this.$store.dispatch('createAnnotator', HelpStore.item).then((response) => {
          this.$store.dispatch('addNotification', {
            type: 'success',
            text: `Annotator created`
          })
          router.push(`/annotator/${response.data.id}`)
        })
      },
      openDetails(data) {
        router.push(`/annotator/${data.id}`)
      },
      selectChanged(items){
        this.selected = items
        if (items.length){
          this.mainEntityId = items[0].id
        }
      },
      removeSelected(item) {
        this.selected = this.selected.filter(_item => item.id != _item.id)
      },
      merge() {
        this.$store.dispatch('mergeAnnotators', {
          mainAnnotatorId: this.mainEntityId,
          annotatorIds: this.selected.filter(annotator => annotator.id != this.mainEntityId).map(annotator => annotator.id)
        }).then(() => {
          this.$store.dispatch('addNotification', {
            type: 'success',
            text: `Annotators merged`
          })
          this.selected = []
          this.mainEntityId = null
          this.key++
        })
      },
    },
    watch: {
      "userSettings"(){
        this.key++
      }
    }
  }
</script>
